<template>
  <WsCreate
    :modelName="modelName"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    parentModelName="checklist_template"
    :parentId="$route.params.id"
    :hasSequence="hasSequence"
  >
  </WsCreate>
</template>

<script>
import model from "@/models/checklist_template";
export default {
  data: () => ({
    modelName: "checklist_template_version",
    label: "點檢表公版版本",
    fields: model.fields.last_version.fields,
    hasSequence: true,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "版本內容",
              fields: ["locales"],
            },
          ],
        },
      ],
      secondary: [],
    },
  }),
};
</script>